module.exports = __webpack_public_path__ + "img/cww_05.5062ef1b.jpg";